import * as React from 'react';

import { DatosAlumno } from '../tipos';
import Campo from './Campo';
import InformacionPersonal from './InformacionPersonal';

type InformacionPersonalAlumnoProps = DatosAlumno;
const InformacionPersonalAlumno: React.FunctionComponent<InformacionPersonalAlumnoProps> = props => {
    const { viveCon, ...resto } = props;
    return (
        <div>
            <InformacionPersonal titulo='Información personal' {...resto} />
            <Campo etiqueta='Vive con' valor={viveCon} />
        </div>
    );
};

export default InformacionPersonalAlumno;



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/InformacionGeneral/componentes/InformacionPersonalAlumno.tsx